// extracted by mini-css-extract-plugin
module.exports = {"RecommendationsPanel":"if2rfyo-H2m0zjvwX9Y-8A==","Divider":"_1OPyn1m5FPqc4lzdKZiOIw=="};